import loader from '../../loader'

export default [
    {
        path: '403',
        meta: {
            title: '403',
        },
        component: loader('views/exception/403.vue')
    },
    {
        path: '404',
        meta: {
            title: '404',
        },
        component: loader('views/exception/404.vue')
    },
    {
        path: '500',
        meta: {
            title: '500',
        },
        component: loader('views/exception/500.vue')
    },
    {
        path: '600',
        meta: {
            title: '链接失效',
        },
        component: loader('views/exception/600.vue')
    }
]